export default __webpack_public_path__ + "static/media/2022_05_23 - Puma - 0456.08d5c75f.jpg";